export default {
  // 列表
  fieldRuleList: "/settings/entityFieldValidationRule/show",
  // 新增
  fieldRuleAdd: "/settings/entityFieldValidationRule/add",
  // 修改
  fieldRuleUpdate: "/settings/entityFieldValidationRule/update",
  // 逻辑删除
  fieldRuleDelete: "/settings/entityFieldValidationRule/delete",
  // 获取数据库表名
  fieldRuleTable: "/settings/entityFieldValidationRule/tableList",
  // 获取数据库表的字段名
  fieldRuleField: "/settings/entityFieldValidationRule/fieldList",
  // 编辑反显
  fieldRuleById: "/settings/entityFieldValidationRule/byId",
};
